<scaffold-dialog [title]="data.title || ''" [size]="'wide'">
  <div scaffoldDialogBody>
    @if (loading) {
      <div class="loading-placeholder-container">
        <div class="loading-placeholder-content">
          <scaffold-loading-animation></scaffold-loading-animation>
        </div>
      </div>
    }
    <div class="view-container">
      <div #contentHolder [innerHTML]="data.content | safeHtml"></div>
    </div>
  </div>
  <div scaffoldDialogButtons>
    <button pButton severity="secondary" (click)="dialogRef.close()">
      {{ 'close' | translation }}
    </button>
    <button
      pButton
      severity="primary"
      [disabled]="loading"
      (click)="getPDF(data.content)">
      PDF
    </button>
  </div>
</scaffold-dialog>
